import moment from "moment";

export const nextMonth = moment()
  .add(1, "month")
  .format();

export const nextDay = moment()
  .add(1, "day")
  .format();

export const today = new Date();

const diffMinutes = (date_time: Date, now: Date) =>
  moment(now).diff(date_time, "minutes");

export const isDateValid = ({
  expiredDate,
  now = new Date()
}: {
  expiredDate: Date;
  now: Date;
}) => (!expiredDate ? false : diffMinutes(expiredDate, now) <= 0);

export const isToday = (currentDate: Date) => {
  return moment(currentDate).isSame(today, "day");
};
